import { AnimatePresence, motion } from "motion/react";
import { act, net } from "../store.js";
import { fmtClock } from "../theme.js";

/** Victory / defeat screen with a Restart button. */
export function EndScreen() {
  const n = net.value;
  const show = n !== null && (n.runPhase === "victory" || n.runPhase === "defeat");
  const victory = n?.runPhase === "victory";
  return (
    <AnimatePresence>
      {show && n !== null && (
        <motion.div
          class="pointer absolute inset-0 flex flex-col items-center justify-center gap-4 bg-[#06090f]/75"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            class="text-5xl font-extrabold tracking-wide"
            style={{ color: victory ? "#6fffa8" : "#ff7a7a" }}
            initial={{ scale: 0.7 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 260, damping: 18 }}
          >
            {victory ? (n.loopIndex > 0 ? `Loop ${n.loopIndex} cleared!` : "Victory!") : "Defeated"}
          </motion.div>
          <div class="opacity-85">
            Survived {fmtClock(n.runClockMs)} · {n.kills} kills ({n.localKills} yours) · reached Lv{" "}
            {n.level}
            {n.loopIndex > 0 && ` · loop ${n.loopIndex}`}
          </div>
          <div class="flex flex-wrap justify-center gap-3">
            {victory && (
              <button
                type="button"
                onClick={() => act()?.action("ascend")}
                title="Keep leveling up and choosing upgrades — your build grows without limit."
                class="rounded-lg border border-amber-400/60 bg-amber-500/20 px-5 py-2 font-semibold hover:bg-amber-500/30"
              >
                Ascend → Loop {n.loopIndex + 1}
                <span class="ml-1 text-xs opacity-75">(upgrade ∞)</span>
              </button>
            )}
            {victory && (
              <button
                type="button"
                onClick={() => act()?.action("continue")}
                title="Carry your current maxed build into the next, harder loop (no further upgrades)."
                class="rounded-lg border border-emerald-400/50 bg-emerald-500/20 px-5 py-2 font-semibold hover:bg-emerald-500/30"
              >
                Continue → Loop {n.loopIndex + 1}
                <span class="ml-1 text-xs opacity-75">(keep build)</span>
              </button>
            )}
            <button
              type="button"
              onClick={() => act()?.action(victory ? "lobby" : "restart")}
              class="rounded-lg border border-sky-400/50 bg-sky-500/20 px-5 py-2 font-semibold hover:bg-sky-500/30"
            >
              {victory ? "Back to Lobby" : "Restart"}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
